import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Container,
  makeStyles,
  TableBody,
  TableHead,
  TablePagination,
  Grid,
  useMediaQuery,
  useTheme,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
//import { useForm } from "react-hook-form";
import { AuthContext, SelectedLabContext } from "../context";
import { operatorServices } from "../services";
import {
  Toast,
  SimpleToolbar,
  Loader,
  PatientAssign,
  Drawer,
  StyledTableCell,
  StyledTableRow,
  BaseTable,
} from "../components";
import { useDrawer } from "../hooks";
import {
  getAssignmentStatusNames,
  capitalizeFirstLetterArray,
  handleDownloadExcel,
  OperatorAssignmentStatus,
  getOperatorAssignmentStatus,
} from "../helpers";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const tableHeader = [
  // "Productos",
  "Código de orden",
  "RUT",
  "Entregado",
  "Paciente",
  "Teléfono",
  "Dirección",
  "Estado",
  "Comentarios de reparto",
];
export default function OperatorHistoryScreen(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const [assignments, setAssignments] = useState([]);
  const { authState, signOut } = useContext(AuthContext);
  const { selectedLab } = useContext(SelectedLabContext);
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(100);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [reload, setReload] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [assignmentId, setAssignmentId] = useState(null);
  const [deliveryStatus, setDeliveryStatus] = useState(null);
  const [failDescription, setFailDescription] = useState("");
  const [errorFail, setErrorFail] = useState(false);
  const [errorFailText, setErrorFailText] = useState("");
  const { isOpen, setIsOpen } = useDrawer();
  // const [tableBody, setTableBody] = useState([]);
  const tableBody = useRef([]);

  useEffect(() => {
    const tableData = assignments.map((assignment) => {
      return [
        // "",
        assignment.orderCode || "No asignado",
        assignment.rut || "",
        "",
        capitalizeFirstLetterArray(
          `${assignment.firstName || ""} ${assignment.lastName || ""}`
        ),
        assignment.phone || "",
        assignment.address || "",
        getAssignmentStatusNames(assignment.status),
        assignment.inDeliveryComments || "",
      ];
    });
    tableBody.current = tableData;
  }, [assignments]);

  useEffect(() => {
    setReload(false);
    getOperatorProducts("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, authState, reload, selectedLab]);

  const getOperatorProducts = async (text) => {
    try {
      setLoading(true);
      const { status, response } = await operatorServices.getOperatorHistory({
        operatorId: authState.user.operator._id,
        page,
        limit,
        token: authState.token,
        text,
        laboratoryId: selectedLab?._id,
      });
      setLoading(false);
      if (status === 200) {
        setAssignments(response.assigments);
        setLimit(response.limit);
        setCount(response.total);
        setPage(response.page);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const confirmationModal = ({ assignment }) => {
    setAssignmentId(assignment._id);
    setOpenAlert(true);
    setFailDescription(assignment.failDescription);
  };

  const updateStatusAssignment = async () => {
    if (failDescription === "") {
      setErrorFail(true);
      setErrorFailText("Debe agregar una descripción");
      return;
    }
    setOpenAlert(false);
    try {
      setLoading(true);
      const { status, response } =
        await operatorServices.updateStatusAssignment({
          status: deliveryStatus,
          assignmentId,
          failDescription,
        });
      setLoading(false);
      if (status === 200) {
        setToastMessage(response.message);
        setReload(true);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const handleSwitchStatus = async ({ id, isDelivered }) => {
    const switchedStatus = isDelivered
      ? "66182a497b4df03548c40405"
      : "66182a037b4df03548c40403";
    try {
      const { status, response } =
        await operatorServices.updateStatusAssignment({
          status: switchedStatus,
          assignmentId: id,
          failDescription: "",
        });
      if (status === 200) {
        setReload(true);
      } else if (status === 401) {
        signOut();
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };
  const optionsToolbar = [
    {
      label: "Export excel",
      action: (e) => {
        handleDownloadExcel({
          filename: "Asignaciones",
          tableHeader: tableHeader,
          tableBody: tableBody.current,
        });
      },
    },
  ];
  return (
    <>
      <Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
      <Grid container style={{ flex: 1 }}>
        <Dialog
          maxWidth="sm"
          fullScreen={fullScreen}
          open={openAlert}
          TransitionComponent={Transition}
        >
          <>
            <DialogTitle id="alert-dialog-slide-title">
              Estado de la entrega
            </DialogTitle>
            <DialogActions style={{ justifyContent: "center" }}>
              <Grid container spacing={2}>
                <Grid item lg={12} xs={12} sm={12}>
                  <FormControl
                    variant="outlined"
                    className={`${classes.formControl}  ${classes.shrinkLabel}`}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      Estado
                    </InputLabel>
                    <Select
                      labelId="demo-mutiple-name-label"
                      id="demo-mutiple-name"
                      value={deliveryStatus}
                      onChange={(e) => setDeliveryStatus(e.target.value)}
                    >
                      {Object.keys(OperatorAssignmentStatus).map((status) => (
                        <MenuItem key={status} value={status}>
                          {getOperatorAssignmentStatus(status)}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={12} xs={12} sm={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    id="description"
                    multiline
                    rows={3}
                    value={failDescription}
                    onChange={(e) => setFailDescription(e.target.value)}
                    label="Descripción de entrega fallida"
                    name="description"
                    autoComplete="description"
                    size="small"
                    error={errorFail}
                    helperText={errorFailText}
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>

                <Grid item lg={6} xs={12} sm={6}>
                  <Button
                    fullWidth
                    className={classes.btnCancel}
                    onClick={() => setOpenAlert(false)}
                    variant="text"
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item lg={6} xs={12} sm={6}>
                  <Button
                    fullWidth
                    className={classes.btnConfirm}
                    onClick={updateStatusAssignment}
                    variant="text"
                  >
                    Aceptar
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </>
        </Dialog>
        {loading && <Loader loading={true} />}
        <Grid item sm={12} xs={12}>
          <div className={classes.root}>
            <Toast
              message={toastMessage}
              open={toast}
              close={() => {
                setToast(false);
              }}
            />
            <Container maxWidth={false}>
              <SimpleToolbar
                isOperator={true}
                reload={() => setReload(true)}
                onFilter={(text) => getOperatorProducts(text)}
                // table={"operatorAssignments"}
                // filename={"Asignaciones"}
                isOpen={isOpen}
                setIsOpen={(value) => setIsOpen(value)}
                options={optionsToolbar}
              />
              <BaseTable tableId="operatorAssignments">
                <TableHead>
                  <StyledTableRow>
                    {/* <StyledTableCell>Productos</StyledTableCell> */}
                    <StyledTableCell>Código de orden</StyledTableCell>
                    <StyledTableCell>Rut</StyledTableCell>
                    <StyledTableCell>Entregado</StyledTableCell>
                    <StyledTableCell>Paciente</StyledTableCell>
                    <StyledTableCell>Telefono</StyledTableCell>
                    <StyledTableCell>Dirección</StyledTableCell>
                    <StyledTableCell>Estado</StyledTableCell>
                    <StyledTableCell>Opciones</StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {assignments.map((assignment, index) => (
                    <PatientAssign
                      index={index}
                      key={assignment._id}
                      isOperator
                      assignment={assignment}
                      onClickAssign={() => confirmationModal({ assignment })}
                      handleSwitchStatus={handleSwitchStatus}
                    />
                  ))}
                </TableBody>
              </BaseTable>
              <TablePagination
                labelRowsPerPage="Registros por página"
                component="div"
                count={count}
                onChangeRowsPerPage={(e) => {
                  setLimit(e.target.value);
                }}
                onChangePage={(e, page) => {
                  setPage(page + 1);
                }}
                page={page - 1}
                rowsPerPage={limit}
                rowsPerPageOptions={[10, 25, 50, 100]}
                classes={{ root: classes.pagination }}
              />
            </Container>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  avatar: {
    marginRight: theme.spacing(2),
  },
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  textField: {
    width: "100%",
  },
  btnCancel: {
    backgroundColor: theme.palette.secondary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
  },
  btnConfirm: {
    backgroundColor: theme.palette.primary.main,
    color: "#FFF",
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "#f44336",
  },
  dialogTitle: {
    textAlign: "Center",
  },
  shrinkLabel: {
    "& > label:nth-child(1)": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    "& > div:nth-child(2)": {
      "& > fieldset": {
        "& > legend": {
          maxWidth: 1000,
        },
      },
    },
  },
  formControl: {
    width: "100%",
    minWidth: 120,
  },
}));
